import { render } from "./TelegramWebhookCard.vue?vue&type=template&id=37c0e4da&scoped=true"
import script from "./TelegramWebhookCard.vue?vue&type=script&lang=js"
export * from "./TelegramWebhookCard.vue?vue&type=script&lang=js"

import "./TelegramWebhookCard.vue?vue&type=style&index=0&id=37c0e4da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c0e4da"]])

export default __exports__